import React from 'react'
import {connect} from "react-redux";
import {setSQFTActiveButton} from "../../../../actions/sqftMenuFunctions";
import {injectIntl} from "react-intl";
import Cropper from "react-cropper";
// import "/node_modules/cropperjs/dist/cropper.min.css";
import "cropperjs/dist/cropper.min.css";

const SqftStepCropSlab = (props) => {
  const {activeSlabUrl, slabAspectRatio} = props;
  const {cropperRef} = props;
  const onCrop = () => {
    //const imageElement = cropperRef ? cropperRef.current : null;
    //const cropper = imageElement ? imageElement.cropper : null;
    //console.log(cropper.getCroppedCanvas().toDataURL());
  };

  return (
    <div className={"slab-content "}>
      {
        activeSlabUrl
          ? <Cropper
            //src="./images/sqft-icons/kitchen-background-6.jpg"
            src={activeSlabUrl}
            style={{ height: 400, width: "100%" }}
            // Cropper.js options
            initialAspectRatio={slabAspectRatio !== 0 ? slabAspectRatio : 2}
            aspectRatio={slabAspectRatio !== 0 ? slabAspectRatio : 2}
            autoCropArea={1}
            guides={false}
            crop={onCrop}
            ref={cropperRef}
            />
          : <div className="message-loading-left-panel-spinner message-loading-left-panel-spinner--small"/>
      }

    </div>
  )
};

const mapStateToProps = (store) => ({
  activeButton: store.sqftMenuState.activeButton,
  filterGroups: store.filterState.filterGroups,
  activeSlabUrl: store.sqftSlabState.activeSlabUrl,
  slabAspectRatio: store.sqftSlabState.slabAspectRatio,
});

const mapDispatchToProps = {
  setSQFTActiveButton,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftStepCropSlab)
)

